import { render, staticRenderFns } from "./messageChart.vue?vue&type=template&id=a4d3ace8&scoped=true&"
import script from "./messageChart.vue?vue&type=script&lang=js&"
export * from "./messageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3ace8",
  null
  
)

export default component.exports